import { RoomStatus } from '@/dto/interface/room.interface';
import { SelectRoom } from '@/pages/Main';
import { deleteItemInLimitNotify } from '@/util/limitNotify';
import { getRoomStatusColor } from '@/util/roomStatus';
import { Modal, notification } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { useMutation } from 'react-query';
import './style.scss';
import { QuestionCircleOutlined, HomeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { appRoutes } from '@/router/routes';
import roomService from '@/services/room.service';

interface IProps {
    selectedRoom: SelectRoom[];
    onSelectRoom: (value: SelectRoom) => void;
    removeSelectRoom: (value: string) => void;
    data: any;
    isDisable?: boolean;
    refetch?: any;
}

const Room: React.FC<IProps> = ({ data, selectedRoom, onSelectRoom, removeSelectRoom, isDisable, refetch }) => {
    const isSelected = selectedRoom?.some((item) => item._id === data?._id?.toString());
    const cannotChangeRoom = isDisable;
    const navigate = useNavigate();

    const { mutate: updateStatus } = useMutation(() => roomService.cleanRoom(data?._id?.toString()), {
        onSuccess: () => {
            refetch();
        },
        onError: (error: any) => {
            notification.error({
                message: 'Đã có lỗi',
            });
        },
    });

    const none = !data?._id;

    const status = data?.roomStatus?.status;

    return none ? (
        <div className="c-room none"></div>
    ) : (
        <div
            className={classNames('c-room', {
                none: none,
                selected: isSelected,
                disable: cannotChangeRoom,
            })}
            onClickCapture={() => {
                if (data?.baotri) {
                    Modal.warning({
                        content: 'PHÒNG ĐANG BẢO TRÌ',
                        okText: 'OK',
                        centered: true,
                    });
                    return;
                } else if (status === RoomStatus?.roomCleanColor) {
                    deleteItemInLimitNotify(data?.roomNo);
                    Modal.confirm({
                        title: 'XÁC NHẬN DỌN DẸP',
                        content: 'Xác nhận đã dọn dẹp phòng xong.',
                        okText: 'OK',
                        cancelText: 'Đóng',
                        onOk: () => updateStatus(),
                        centered: true,
                        icon: <QuestionCircleOutlined />,
                    });
                    return;
                } else {
                    navigate(`${appRoutes.MAIN.CHECK_IN}/${data?._id?.toString()}`, { state: { new: true } });
                }
            }}
            style={{
                background: `${data?.baotri ? '#595959' : data?.roomStatus?.bgColor}`,
                borderColor: `${data?.roomType?.bgColor}`,
            }}
            id={data?._id}
            tabIndex={1}
        >
            <div className={`c-room__title`}>
                <h3>{data?.roomNo}</h3>
                <HomeOutlined />
            </div>
        </div>
    );
};

export default Room;
